// @flow

import type { AppAdoptionState } from "./types";

export const initialState: AppAdoptionState = {
  highlights: {
    isLoading: false,
    error: null,
    onboardedToApp: {
      onboarded: 0,
      notOnboarded: 0,
    },
    downloads: [],
  },
  departments: {
    isLoading: false,
    error: null,
    data: [],
  },
};

export default initialState;
